import { render, staticRenderFns } from "./hospital.vue?vue&type=template&id=4ab45bb8&scoped=true&"
import script from "./hospital.vue?vue&type=script&lang=js&"
export * from "./hospital.vue?vue&type=script&lang=js&"
import style0 from "./hospital.vue?vue&type=style&index=0&id=4ab45bb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab45bb8",
  null
  
)

export default component.exports